// extracted by mini-css-extract-plugin
export var box = "_45-0";
export var check = "_45-1";
export var checkboxButton = "_45-6";
export var checkboxGroup = "_45-5";
export var disabled = "_45-7";
export var ghost = "_45-9";
export var input = "_45-2";
export var label = "_45-4";
export var normal = "_45-8";
export var uncheck = "_45-3";